import { defineReactiveModel, Persistable, belongsTo } from "vue-app-utils";
import Model from "@/models/model";
import { matchupIndices } from "@/utils/race-utils";

const Squad = {
  extends: Model,
  mixins: [
    Persistable,
    belongsTo("league")
  ],
  data () {
    return {
      locationId: "",
      memberIds: [],
      name: ""
    };
  },
  computed: {
    title () {
      return this.name || "Untitled team";
    },
    homeLocation () {
      return this.league.locations.find(l => l.id === this.locationId);
    },
    members () {
      return this.memberIds
        .map(id => this.league.members.find(m => m.id === id))
        .filter(Boolean);
    },
    membersSortedByStartOfLeagueOrdinal () {
      return this.members.sort((a, b) => {
        const diff = b.startOfLeagueOrdinal - a.startOfLeagueOrdinal;
        if (diff !== 0) return diff;
        return a.name.localeCompare(b.name);
      });
    }
  },
  methods: {
    pickTeamMembers (home, gameNumber) {
      const indices = matchupIndices(gameNumber)[home ? 0 : 1];
      const sorted = [...this.membersSortedByStartOfLeagueOrdinal];
      // TODO: remove Player N padding once squads are guaranteed full
      while (sorted.length < 3) {
        sorted.push({ name: `Player ${sorted.length}` });
      }
      return indices.map(i => sorted[i]);
    }
  }
};

export default defineReactiveModel(Squad);